import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import { AssetImage } from 'owa-timestream-asset-sdk';
import type { FileLinkThumbnailViewProps } from '../schema';
import useFileLinkThumbnailViewState from '../hooks/useFileLinkThumbnailViewState';

export default observer(function FileLinkThumbnailView(props: FileLinkThumbnailViewProps) {
    const { imageProps, shouldShowThumbnail } = useFileLinkThumbnailViewState(props);

    return shouldShowThumbnail ? (
        <div className={styles.thumbnailContainer}>
            <AssetImage {...imageProps} role={'presentation'} />
        </div>
    ) : null;
});
